import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-table',
	templateUrl:'./TablePluginCompPage.html',
	styles: [],
	styleUrls:['./TablePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class TablePluginCompPage
{
	mdContent_1103 = `\`\`\`java
import com.jwebmp.core.base.html.Table;
\`\`\``;
	mdContent_1104 = `\`\`\`java
Table()
\`\`\``;
	mdContent_1105 = `\`\`\`java
Table&lt;?&gt; table = new Table&lt;&gt;();
TableHeaderGroup&lt;?&gt; head = table.addHeader();
head.addHeaderRow("Name", "Email");
TableBodyGroup&lt;?&gt; body = table.addBody();
body.addRow("Alice", "alice@ex.com");
\`\`\``;
}
